import {
  Button,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField
} from "@mui/material";
import { styled } from "@mui/system";
import { useEffect } from "react";
import { NumericFormat } from "react-number-format";

const StyledTextField = styled(TextField)({
  minWidth: "80px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#E9EAEC",
    borderRadius: "10px"
  },
  "& .MuiInputBase-root.Mui-disabled": {
    backgroundColor: "rgb(255, 255, 255)",
    borderColor: "rgb(179, 179, 179)",
    outline: "none",
    "& fieldset": {
      borderColor: "rgb(179, 179, 179)",
      borderWidth: "0.5px"
    }
  }
});

export const Section10 = ({
  formState,
  handleChange,
  handleSectionComplete,
  reportId,
  isEditingEnabled
}) => {
  useEffect(() => {
    const calculatedTotal =
      Number(formState.income.welfare.number || 0) +
      Number(formState.income.tithe.number || 0) +
      Number(formState.income.offering.number || 0) +
      Number(formState.income.gift.number || 0) +
      Number(formState.income.other.number || 0);

    handleChange("income", "total", {
      ...formState.income.total,
      number: calculatedTotal
    });
  }, [
    formState.income.welfare.number,
    formState.income.tithe.number,
    formState.income.offering.number,
    formState.income.gift.number,
    formState.income.other.number
  ]);

  return (
    <Stack spacing={2}>
      <TableContainer sx={{ overflowX: "auto" }}>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell></TableCell>
              <TableCell align="center">በአሃዝ</TableCell>
              <TableCell align="center">በፊደል</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>በኩራት</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.income.welfare.number}
                  onValueChange={values => {
                    handleChange("income", "welfare", {
                      ...formState.income.welfare,
                      number: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <StyledTextField
                  fullWidth
                  defaultValue={formState.income.welfare.in_words}
                  onBlur={e =>
                    handleChange("income", "welfare", {
                      ...formState.income.welfare,
                      in_words: e.target.value
                    })
                  }
                  key={formState.income.welfare.in_words}
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>የአሥራት</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.income.tithe.number}
                  onValueChange={values => {
                    handleChange("income", "tithe", {
                      ...formState.income.tithe,
                      number: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <StyledTextField
                  fullWidth
                  defaultValue={formState.income.tithe.in_words}
                  onBlur={e =>
                    handleChange("income", "tithe", {
                      ...formState.income.tithe,
                      in_words: e.target.value
                    })
                  }
                  key={formState.income.tithe.in_words}
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>መባ</TableCell>
              <TableCell>
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.income.offering.number}
                  onValueChange={values => {
                    handleChange("income", "offering", {
                      ...formState.income.offering,
                      number: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell>
                <StyledTextField
                  fullWidth
                  defaultValue={formState.income.offering.in_words}
                  onBlur={e =>
                    handleChange("income", "offering", {
                      ...formState.income.offering,
                      in_words: e.target.value
                    })
                  }
                  key={formState.income.offering.in_words}
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>በስጦታ</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.income.gift.number}
                  onValueChange={values => {
                    handleChange("income", "gift", {
                      ...formState.income.gift,
                      number: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <StyledTextField
                  fullWidth
                  type="text"
                  defaultValue={formState.income.gift.in_words}
                  onBlur={e =>
                    handleChange("income", "gift", {
                      ...formState.income.gift,
                      in_words: e.target.value
                    })
                  }
                  key={formState.income.gift.in_words}
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ልዩ ልዩ</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.income.other.number}
                  onValueChange={values => {
                    handleChange("income", "other", {
                      ...formState.income.other,
                      number: values.floatValue
                    });
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <StyledTextField
                  fullWidth
                  type="text"
                  defaultValue={formState.income.other.in_words}
                  onBlur={e =>
                    handleChange("income", "other", {
                      ...formState.income.other,
                      in_words: e.target.value
                    })
                  }
                  key={formState.income.other.in_words}
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>ጠቅላላ ድምር</TableCell>
              <TableCell align="center">
                <NumericFormat
                  customInput={StyledTextField}
                  thousandSeparator
                  allowNegative={false}
                  value={formState.income.total.number}
                  inputProps={{
                    readOnly: true
                  }}
                  fullWidth
                  disabled={!isEditingEnabled}
                />
              </TableCell>
              <TableCell align="center">
                <StyledTextField
                  fullWidth
                  type="text"
                  defaultValue={formState.income.total.in_words}
                  onBlur={e =>
                    handleChange("income", "total", {
                      ...formState.income.total,
                      in_words: e.target.value
                    })
                  }
                  key={formState.income.total.in_words}
                  disabled={!isEditingEnabled}
                />
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
      {!reportId && (
        <Stack alignItems="flex-start">
          <Button
            variant="contained"
            color="primary"
            onClick={() => handleSectionComplete(11)}
          >
            ቀጥል
          </Button>
        </Stack>
      )}
    </Stack>
  );
};
